<template>
  <div class="join-us">
    <div class="join-us-wrap">
      <img v-if="IsPC" class="join-us-bg" src="~@/assets/index/joinUs/底图@2x.png" alt="">
      <img v-else class="join-us-bg" src="~@/assets/mobile/joinUs/底图@2x.png" alt="">
      <div class="join-us-title-wrap">
        <div class="join-us-title">JOIN US</div>
        <div class="join-us-des">
          <span>一起加入金十大家庭</span>
          <img class="join-us-des-icon" src="~@/assets/index/joinUs/箭头@2x.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IsPC } from '@/utils'
export default {
  data() {
    return {
      IsPC: IsPC()
    }
  }
}
</script>

<style lang="scss" scoped>
.join-us {
    position: relative;
    width: 100%;
    height: 100%;
    // background: url('~@/assets/index/joinUs/底图@2x.png') no-repeat;
    // background-size: 100% 100%;
    .join-us-bg {
      position: absolute;
      left: 0;
      right: 0;
      width: 100%;
    //   z-index: -1;
    }
    .join-us-title-wrap {
        position: relative;
        width: 1280px;
        margin: 0 auto;
        padding-top: 59px;
        .join-us-title {
            margin-bottom: 12px;
            height: 89px;
            font-size: 60px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: bold;
            color: #3D4351;
            line-height: 89px;
            letter-spacing: 1px;
        }
        .join-us-des {
            display: flex;
            align-items: center;
            height: 24px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3D4351;
            .join-us-des-icon {
                width: 37px;
                margin-left: 8px;
            }
        }
    }
}
@media screen and (max-width: 1680px) {
.join-us {
    position: relative;
    width: 100%;
    height: 100%;
    .join-us-bg {
      position: absolute;
      left: 0;
      right: 0;
      width: 100%;
    }
    .join-us-title-wrap {
        position: relative;
        width: calc(1280px / 1.3);
        margin: 0 auto;
        padding-top: calc(59px / 1.3);
        .join-us-title {
            margin-bottom: calc(12px / 1.3);
            height: calc(89px / 1.3);
            font-size: calc(60px / 1.3);
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: bold;
            color: #3D4351;
            line-height: calc(89px / 1.3);
            letter-spacing: calc(1px / 1.3);
        }
        .join-us-des {
            display: flex;
            align-items: center;
            height: calc(24px / 1.3);
            font-size: calc(16px / 1.3);
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3D4351;
            .join-us-des-icon {
                width: calc(37px / 1.3);
                margin-left: calc(8px / 1.3);
            }
        }
    }
}
}

@media screen and (max-width:820px) {
.join-us {
    position: relative;
    width: 100%;
    height: 100%;
    .join-us-bg {
      position: absolute;
      left: 0;
      right: 0;
      width: 100%;
    }
    .join-us-title-wrap {
        position: relative;
        width: 339px;
        margin: 0 auto;
        padding-top: 12px;
        .join-us-title {
            height: 40px;
            font-size: 27px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: bold;
            color: #3D4351;
            line-height: 40px;
            letter-spacing: 1px;
        }
        .join-us-des {
            display: flex;
            align-items: center;
            height: 14px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #3D4351;
            .join-us-des-icon {
                width: 22px;
                margin-left: 5px;
            }
        }
    }
}
}
</style>
